export default __webpack_public_path__ + "static/media/section2_8.526530d9.png";